import { create } from "zustand";

let _nextId = 1;

export const useNotificationStore = create((set, get) => ({
  notifications: [],
  unreadCount: 0,

  /**
   * Add a notification.
   * @param {{ type: "success"|"error"|"trade"|"signal"|"info", title: string, message?: string, icon?: string }} n
   */
  addNotification: (n) => {
    const id = _nextId++;
    const notification = {
      id,
      type: n.type || "info",
      title: n.title,
      message: n.message || "",
      icon: n.icon || null,
      timestamp: Date.now(),
      read: false,
    };
    set((state) => ({
      notifications: [notification, ...state.notifications].slice(0, 100),
      unreadCount: state.unreadCount + 1,
    }));
    return id;
  },

  removeNotification: (id) => {
    set((state) => ({
      notifications: state.notifications.filter((n) => n.id !== id),
    }));
  },

  markAllRead: () => {
    set((state) => ({
      notifications: state.notifications.map((n) => ({ ...n, read: true })),
      unreadCount: 0,
    }));
  },

  clearAll: () => {
    set({ notifications: [], unreadCount: 0 });
  },
}));
